<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title class="ion-text-center"> Test </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content  class="ion-padding" [fullscreen]="true">
  <ion-header class="ion-margin-bottom">
    City card page
  </ion-header>
</ion-content>

